import moment from "moment";

export default function CreateReconnectionWorkItemModel(mergedData) {
  return {
    workorderid: mergedData.id,
    workordername: `${mergedData.categoryName} at ${mergedData.siteName}`,
    workordercategoryid: mergedData.category,
    workordercategoryname: mergedData.categoryName,
    name: `${mergedData.categoryName} at ${mergedData.siteName}`,
    customerresidentname: mergedData.customername,
    customeremail: mergedData.customeremail,
    customercontactnumber: mergedData.customerphone,
    customervulnerability: mergedData.customervulnerability,
    siteid: mergedData.siteId,
    sitename: mergedData.siteName,
    propertyid: mergedData.propertyId,
    propertyname: mergedData.propertyName,
    propertynumber: mergedData.propertyNumber,
    jobspecificaccessnotes: mergedData.jobSpecificAccessNotes,
    reconnectelectricity: mergedData.reconnectelectricity,
    reconnectheat: mergedData.reconnectheat,
    reconnecthotwater: mergedData.reconnecthotwater,
    workitemagreement: mergedData.appointmentConfirmed,
    workitemagreementtitle: mergedData.appointmentConfirmedTitle,
    preferredappointmentdate: moment(
      mergedData.preferredAppointmentDate
    ).toISOString(),
    preferredappointmenttimeslot: mergedData.preferredAppointmentSlot,
    preferredappointmenttimeslottitle: mergedData.preferredAppointmentSlotTitle,
    workitemtemplateid: mergedData.workitemtemplateid,
    workitemtemplateref: mergedData.workitemtemplateref,
    propertyaccessnotes: mergedData.propertyaccessnotes,
    redflag: mergedData.redflag,
    idempotencyGuid: mergedData.idempotencyGuid,
    createdBy: mergedData.createdBy,
    noAccessattempts: mergedData.noAccessAttempts,
  };
}
